import { Component} from '@angular/core';
import { RouterModule } from '@angular/router';

import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';


@Component({
  selector: 'app-local-deduction-rates',
  templateUrl: './local-deduction-rates.component.html',
  styleUrls: ['./local-deduction-rates.component.scss'],
  standalone: true,
  imports: [RouterModule, MatIconModule, MatMenuModule, MatButtonModule, MatSelectModule, MatOptionModule],
})
export class LocalDeductionRatesComponent {
    thisYear = new Date().getFullYear();

  constructor(

  ) {
  }

}
